<script setup>
  import { computed } from 'vue';
  import { useMediaQuery } from '@/composables/useMediaQuery';

  const isDesktop = useMediaQuery('(min-width: 840px)');

  const listClass = computed(() => isDesktop.value ? 'jwx-page-header__actions' : 'jwx-action-menu__list');
  const itemClass = computed(() => isDesktop.value ? 'jwx-page-header__action' : 'jwx-action-menu__action');
  const buttonClass = computed(() => isDesktop.value ? 'jwx-page-header__button' : 'jwx-action-menu__action-button');
  const iconClass = computed(() => isDesktop.value ? 'jwx-page-header__action-icon' : 'jwx-action-menu__action-icon');
  const labelClass = computed(() => isDesktop.value ? 'jwx-page-header__action-label' : 'jwx-action-menu__action-label');
  const classes = computed(() => ({ item: itemClass.value, button: buttonClass.value, icon: iconClass.value, label: labelClass.value }));
</script>

<template>  
  <ul :class="listClass">
    <slot name="default" :classes="classes" :isDesktop="isDesktop" ></slot>
  </ul>
</template>